"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserProfile = void 0;
const react_1 = require("react");
const useAuth_1 = require("./useAuth");
const amplifyBootstrap_1 = require("../utils/amplifyBootstrap");
const useUserProfile = (options) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const { currentSession } = (0, useAuth_1.useAuth)();
    const handleSuccess = (0, react_1.useCallback)((response) => {
        setError(null);
        if (options?.onSuccess) {
            options.onSuccess(response);
        }
    }, [options]);
    const handleError = (0, react_1.useCallback)((err) => {
        setError(err);
        if (options?.onError) {
            options.onError(err);
        }
    }, [options]);
    const updateUserDetails = (0, react_1.useCallback)(async (details) => {
        setIsLoading(true);
        setError(null);
        try {
            // Get current session for authentication
            const session = await currentSession();
            const idToken = session.tokens?.idToken?.toString();
            if (!idToken) {
                throw new Error('No authentication token available');
            }
            const result = await amplifyBootstrap_1.API.post('/update-user-details', {
                body: details,
                headers: {
                    'Authorization': `Bearer ${idToken}`,
                },
            });
            handleSuccess(result);
            return result;
        }
        catch (err) {
            const error = err instanceof Error ? err : new Error(String(err));
            handleError(error);
            throw error;
        }
        finally {
            setIsLoading(false);
        }
    }, [currentSession, handleSuccess, handleError]);
    const updatePhoneNumber = (0, react_1.useCallback)(async (phoneNumber) => updateUserDetails({ phoneNumber }), [updateUserDetails]);
    return {
        updatePhoneNumber,
        updateUserDetails,
        isLoading,
        error,
    };
};
exports.useUserProfile = useUserProfile;
